import { Device, MediaFile } from "@fairfleet/geotab";
import { MaintenanceWorkOrder } from "./MaintenanceWorkOrder";
import { MaintenanceType } from "./MaintenanceWorkRequest";

export const STATUS_MAP = {
  1: "open",
  2: "assigned",
  3: "inProgress",
  4: "onHold",
  5: "completed",
  6: "cancelled",
} as const;

export type StatusCode = keyof typeof STATUS_MAP;

export interface MaintenanceWorkOrderJob {
  device: Device;
  workOrder: MaintenanceWorkOrder;
  severityCode: number;
  statusCode: StatusCode; // 1 - Offen 2 - zugewiesen 3 - wird ausgeführt 4 - In warteschleife 5 - Abgeschlossen 6 - Abgebrochen
  costCurrency: string;
  triggeredDate: Date;
  maintenanceType: MaintenanceType;
  odometerReading: string;
  engineHoursReading: string;
  engineHoursReadingInHours: number;
  dateTime: Date;
  reference: string;
  eventDescription: string;
  description: string;
  mediaFiles: MediaFile[];
  updateDate: Date;
  currencyConversionFailed: boolean;
  isClosed: boolean;
  version: string;
  id: string;
}
